import { render, staticRenderFns } from "./esta_eventosivigila.vue?vue&type=template&id=4e338642"
import script from "./esta_eventosivigila.vue?vue&type=script&lang=js"
export * from "./esta_eventosivigila.vue?vue&type=script&lang=js"
import style0 from "./esta_eventosivigila.vue?vue&type=style&index=0&id=4e338642&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports